import React from 'react';

import { LEVEL_TRAVEL_OPERATOR_ID } from 'src/constants/flights';
import type { PropsFromRedux } from '.';

export const ManagerInfo = ({
  operatorId,
  aviaSupplierCode,
  hotelSupplierCode,
  isLoggedUser,
}: PropsFromRedux): JSX.Element | null => {
  const showSupplierDetails =
    isLoggedUser && operatorId === LEVEL_TRAVEL_OPERATOR_ID;
  if (!showSupplierDetails) return null;
  return (
    <div>
      Авиа: {aviaSupplierCode}, Отель: {hotelSupplierCode}
    </div>
  );
};
